














































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { getReport, getrglOnLine } from '@/api/api.config'
import { Component, Vue } from 'vue-property-decorator'
import html2canvas from 'html2canvas'

@Component
export default class Online extends Vue {
vShow(vShow: any) {
throw new Error('Method not implemented.');
}
  orderId: any = "";
  lists: any = {};
  canvasImageUrl: any = "";
  isDom: any = true;
  bgimg: any = require("../../assets/images/zhongqiyanlogo.png");
Overlay: boolean = false;
jiaocha: any;
lianghao: any;
zhengchang: any;
  range(res: any) {
    let img = require('@/assets/images/jt.png')
    var chartDom = document.getElementById('range')
    var chartDom1 = document.getElementById('range1')
    var myChart = (this as any).$echarts.init(chartDom)
    var myChart1 = (this as any).$echarts.init(chartDom1)
    let decline = res.fullChargedDrivingMile
    let rateMileage = res.rateMileage
    let comprehensiveEvaluate = res.comprehensiveEvaluate
    console.log(rateMileage)
    let positionLeft = 1,
      max = 100 + 2 * positionLeft
    var option = {
      grid: {
        top: '0%',
        left: '0%',
        right: '0%',
        bottom: '0%',
      },
      xAxis: {
        type: 'value',
        max: rateMileage,
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        type: 'category',
        inverse: false,
        data: [],
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      series: [
        {
          //间距
          type: 'bar',
          barWidth: 20,
          stack: 'b',
          legendHoverLink: false,
          itemStyle: {
            normal: {
              color: 'rgba(0,0,0,0)',
            },
          },

          data: [positionLeft],
        },
        {
          name: 'XXX',
          type: 'pictorialBar',
          // symbol:
          //   "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhNJREFUeNq0llsoLVEcxme27ZJEPLimXJI4yaMQxZOkePN0IukQdZIXOiFFSrnkQUnigTydDkleSOLxpJRc6qBc6uSE3G8P+P71zWns9phlX776tWdmrzXfrFlrffPXt19fNQUlglLwBTjBM6/L8R1YA4vg6aOb6DZmOeAbOAYzYBO8uLQJA8V8mL9gCFx+xiwIdIFbMMhfFaWBFvALLKiYRYNuMAB2Nc9UD4I5yv9yuDSK4khavTASjYBD0G5lpoM+voYLzXvNglNQ4c6sBvwEJ5rvNArKQKTZLATkuptUH6gHNJvNKsGk5h8dcGQhhlkeWNX8J3ljJQ6mwCNQiZJkMAfuObdtIECh3wooEKMUsKfQIRQsgySeJ3DjSwB02PSVhwuUkcUwZuxUbjIy6zu3ja0cXImPCm3jLK5H8B5KZtdMDjutWVxfBw8K/XUH5ytFofFv16yDrkCD4orUZYGcc95U1ATmQRGNphUTRwZz5OTJDV+lSiYukc9IFte8sanlCav8tKHFIwtsG2YbIAOE+8HsKwP+Xer3cpP6UrEg3wh4s9k+V1ydj4wkcfrBD6sv9RQbVXtpJEXQMOgEZ1ZmGssC46sd5oFRNssCmZI/5j+cFh0mQCYYY3KMK6REKmhkGVfrLgJ1hSK1kB9X0Q4T54zVUyyXdbxsWpYB/zwtUl33Szprw3BWv2K69ZGBWW8CDAD7MHTPqrySXgAAAABJRU5ErkJggg==",
          symbolSize: [20, 20],
          symbolOffset: [5, -3],
          z: 12,
          itemStyle: {
            normal: {
              color: '#48a878',
            },
          },
          data: [
            {
              value: decline,
              symbolPosition: 'end',
            },
          ],
        },
        {
          //内
          type: 'bar',
          barWidth: 20,
          stack: 'b',
          // label: {
          //   normal: {
          //     show: true,
          //     position: "top",
          //     textStyle: {
          //       color: "#FF5B19 ",
          //     },
          //     rich: {
          //       img1: {
          //         backgroundColor: {
          //           image: img,
          //         },
          //       },
          //     },
          //     // formatter: function (e: any) {
          //     //   return (
          //     //     `${img1}` +
          //     //     ((e.value / (max - 2 * positionLeft)) * 100).toFixed(2) +
          //     //     "%"
          //     //   );
          //     // },
          //     formatter: function (param: any) {
          //       var res = "";
          //       res +=
          //         "\n {img1|}" +
          //         ((param.value / (max - 2 * positionLeft)) * 100).toFixed(0) +
          //         "%";
          //       return res;
          //     },
          //   },
          // },
          legendHoverLink: false,
          silent: true,
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              color: new (this as any).$echarts.graphic.LinearGradient(
                0,
                0,
                1,
                0,
                [
                  {
                    offset: 0,
                    color: "#e4f2eb",
                  },
                  {
                    offset: 1,
                    color: "#7cc19f",
                  },
                ]
              ),
            },
          },

          data: [decline],
        },
        {
          //框
          type: 'bar',
          barWidth: 30,
          barGap: '-125%',
          label: {
            normal: {
              show: false,

              position: 'right',
              textStyle: {
                color: '#000',
              },
            },
          },
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              color: 'rgba(0,0,0,0)', //底色
              borderWidth: 2,
              borderColor: '#89c7a8',
            },
          },
          data: [rateMileage],
          z: 5,
        },
      ],
    }
    var option1 = {
      grid: {
        top: '0%',
        left: '5%',
        right: '5%',
        bottom: '0%',
      },
      xAxis: {
        type: 'value',
        max: max,
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        type: 'category',
        inverse: false,
        data: [],
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      series: [
        {
          //间距
          type: 'bar',
          barWidth: 4,
          stack: 'b',
          legendHoverLink: false,
          itemStyle: {
            normal: {
              color: 'rgba(0,0,0,0)',
            },
          },

          data: [positionLeft],
        },
        {
          name: 'XXX',
          type: 'pictorialBar',
          // symbol:
          //   "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhNJREFUeNq0llsoLVEcxme27ZJEPLimXJI4yaMQxZOkePN0IukQdZIXOiFFSrnkQUnigTydDkleSOLxpJRc6qBc6uSE3G8P+P71zWns9phlX776tWdmrzXfrFlrffPXt19fNQUlglLwBTjBM6/L8R1YA4vg6aOb6DZmOeAbOAYzYBO8uLQJA8V8mL9gCFx+xiwIdIFbMMhfFaWBFvALLKiYRYNuMAB2Nc9UD4I5yv9yuDSK4khavTASjYBD0G5lpoM+voYLzXvNglNQ4c6sBvwEJ5rvNArKQKTZLATkuptUH6gHNJvNKsGk5h8dcGQhhlkeWNX8J3ljJQ6mwCNQiZJkMAfuObdtIECh3wooEKMUsKfQIRQsgySeJ3DjSwB02PSVhwuUkcUwZuxUbjIy6zu3ja0cXImPCm3jLK5H8B5KZtdMDjutWVxfBw8K/XUH5ytFofFv16yDrkCD4orUZYGcc95U1ATmQRGNphUTRwZz5OTJDV+lSiYukc9IFte8sanlCav8tKHFIwtsG2YbIAOE+8HsKwP+Xer3cpP6UrEg3wh4s9k+V1ydj4wkcfrBD6sv9RQbVXtpJEXQMOgEZ1ZmGssC46sd5oFRNssCmZI/5j+cFh0mQCYYY3KMK6REKmhkGVfrLgJ1hSK1kB9X0Q4T54zVUyyXdbxsWpYB/zwtUl33Szprw3BWv2K69ZGBWW8CDAD7MHTPqrySXgAAAABJRU5ErkJggg==",
          symbolSize: [8, 10],
          symbolOffset: [5, -2],
          z: 12,
          itemStyle: {
            normal: {
              color: '#48a878',
            },
          },
          data: [
            {
              value: comprehensiveEvaluate,
              symbolPosition: 'end',
            },
          ],
        },
        {
          //内
          type: 'bar',
          barWidth: 4,
          stack: 'b',
          label: {
            normal: {
              show: false,
              position: 'right',
              textStyle: {
                color: '#FF5B19',
              },
              formatter: function (e: any) {
                return (
                  ((e.value / (max - 2 * positionLeft)) * 100).toFixed(2) + "%"
                );
              },
            },
          },
          legendHoverLink: false,
          silent: true,
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              color: new (this as any).$echarts.graphic.LinearGradient(
                0,
                0,
                1,
                0,
                [
                  {
                    offset: 0,
                    color: "#e4f2eb",
                  },
                  {
                    offset: 1,
                    color: "#7cc19f",
                  },
                ]
              ),
            },
          },

          data: [comprehensiveEvaluate],
        },
        {
          //框
          type: 'bar',
          barWidth: 10,
          barGap: '-175%',
          label: {
            normal: {
              show: false,

              position: 'right',
              textStyle: {
                color: '#000',
              },
            },
          },
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              color: 'rgba(0,0,0,0)', //底色
              borderWidth: 2,
              borderColor: '#89c7a8',
            },
          },
          data: [max],
          z: 5,
        },
      ],
    }
    myChart.setOption(option)
    myChart1.setOption(option1)
  }

  range2(res: any) {
    var chartDom = document.getElementById('range2')
    var chartDom1 = document.getElementById('range3')
    var chartDom2 = document.getElementById('range4')
    var chartDom3 = document.getElementById('range5')
    var chartDom4 = document.getElementById('range6')
    var myChart = (this as any).$echarts.init(chartDom)
    var myChart1 = (this as any).$echarts.init(chartDom1)
    var myChart2 = (this as any).$echarts.init(chartDom2)
    var myChart3 = (this as any).$echarts.init(chartDom3)
    var myChart4 = (this as any).$echarts.init(chartDom4)
    let volumeScore = res.volumeScore
    // let volumeEvaluate = res.volumeEvaluate;
    // console.log(res.volumeEvaluate);
    console.log()

    let voltConsistenceScore = res.voltConsistenceScore
    let internalResistanceScore = res.internalResistanceScore
    let selfDischargeRateScore = res.selfDischargeRateScore
    let temperatureConsistenceScore = res.temperatureConsistenceScore
    // volumeScore<30?'#ff0000':'',volumeScore>30?'#ff5b19':'',volumeScore>70?'#48a878':''
    // let border =
    //   volumeScore < 30
    //     ? "#ff0000"
    //     : volumeScore > 30 && volumeScore <= 70
    //     ? "#ff5b19"
    //     : volumeScore > 70
    //     ? "#48a878"
    //     : "";
    let border =
      res.volumeEvaluate === '较差'
        ? (volumeScore = 30) && '#ff0000'
        : res.volumeEvaluate === '良好'
        ? (volumeScore = 70) && '#ff5b19'
        : res.volumeEvaluate === '正常'
        ? (volumeScore = 100) && '#48a878'
        : ''
    let border1 =
      internalResistanceScore < 30
        ? '#ff0000'
        : internalResistanceScore > 30 && internalResistanceScore <= 70
        ? '#ff5b19'
        : internalResistanceScore > 70
        ? '#48a878'
        : ''
    let border2 =
      voltConsistenceScore < 30
        ? '#ff0000'
        : voltConsistenceScore > 30 && voltConsistenceScore <= 70
        ? '#ff5b19'
        : voltConsistenceScore > 70
        ? '#48a878'
        : ''

    let border3 =
      selfDischargeRateScore < 30
        ? '#ff0000'
        : selfDischargeRateScore > 30 && selfDischargeRateScore <= 70
        ? '#ff5b19'
        : selfDischargeRateScore > 70
        ? '#48a878'
        : ''

    let border4 =
      temperatureConsistenceScore < 30
        ? '#ff0000'
        : temperatureConsistenceScore > 30 && temperatureConsistenceScore <= 70
        ? '#ff5b19'
        : temperatureConsistenceScore > 70
        ? '#48a878'
        : ''
    // let color =
    //   volumeScore < 30
    //     ? "#ff0000"
    //     : volumeScore > 30 && volumeScore <= 70
    //     ? "#ff5b19"
    //     : volumeScore > 70
    //     ? "#48a878"
    //     : "";
    let color =
      res.volumeEvaluate === '较差'
        ? (volumeScore = 30) && '#ff0000'
        : res.volumeEvaluate === '良好'
        ? (volumeScore = 70) && '#ff5b19'
        : res.volumeEvaluate === '正常'
        ? (volumeScore = 100) && '#48a878'
        : ''
    let color1 =
      internalResistanceScore < 30
        ? '#ff0000'
        : internalResistanceScore > 30 && internalResistanceScore <= 70
        ? '#ff5b19'
        : internalResistanceScore > 70
        ? '#48a878'
        : ''
    let color2 =
      voltConsistenceScore < 30
        ? '#ff0000'
        : voltConsistenceScore > 30 && voltConsistenceScore <= 70
        ? '#ff5b19'
        : voltConsistenceScore > 70
        ? '#48a878'
        : ''

    let color3 =
      selfDischargeRateScore < 30
        ? '#ff0000'
        : selfDischargeRateScore > 30 && selfDischargeRateScore <= 70
        ? '#ff5b19'
        : selfDischargeRateScore > 70
        ? '#48a878'
        : ''
    let color4 =
      temperatureConsistenceScore < 30
        ? '#ff0000'
        : temperatureConsistenceScore > 30 && temperatureConsistenceScore <= 70
        ? '#ff5b19'
        : temperatureConsistenceScore > 70
        ? '#48a878'
        : ''

    let number =
      volumeScore < 30
        ? 1
        : volumeScore > 30 && volumeScore <= 70
        ? 3
        : volumeScore > 70
        ? 4
        : ''
    let number1 =
      internalResistanceScore < 30
        ? 1
        : internalResistanceScore > 30 && internalResistanceScore <= 70
        ? 3
        : internalResistanceScore > 70
        ? 4
        : ''
    let number2 =
      voltConsistenceScore < 30
        ? 1
        : voltConsistenceScore > 30 && voltConsistenceScore <= 70
        ? 3
        : voltConsistenceScore > 70
        ? 4
        : ''
    let number3 =
      selfDischargeRateScore < 30
        ? 1
        : selfDischargeRateScore > 30 && selfDischargeRateScore <= 70
        ? 3
        : selfDischargeRateScore > 70
        ? 4
        : ''
    let number4 =
      temperatureConsistenceScore < 30
        ? 1
        : temperatureConsistenceScore > 30 && selfDischargeRateScore <= 70
        ? 3
        : temperatureConsistenceScore > 70
        ? 4
        : ''
    let category = [{ name: '', value: volumeScore }] // 类别
    let volumeEvaluate = res.volumeEvaluate
    let total = 100.8 // 数据总数
    var datas: any = []
    category.forEach((value) => {
      datas.push(value.value)
    })
    var option = {
      grid: {
        left: "5%",
        top: "10%", // 设置条形图的边距
        right: "5%",
        bottom: "10%",
      },
      xAxis: {
        max: total,
        show: false,
      },
      yAxis: [
        {
          type: 'category',
          inverse: false,
          data: category,
          show: false,
        },
      ],
      series: [
        {
          // 内
          type: 'bar',
          barWidth: 6,
          legendHoverLink: false,
          silent: true,
          // label: {
          //   show: true,
          //   position: "top",
          //   color: color,
          //   formatter: function (data: any) {
          //     return data.value + `(${volumeEvaluate})`;
          //   },
          // },
          itemStyle: {
            color: color,
            barBorderRadius: 20,
          },
          data: category,
          z: 0,
          animationEasing: 'elasticOut',
        },
        {
          // 分隔
          type: 'pictorialBar',
          itemStyle: {
            normal: {
              color: 'white',
            },
          },
          symbolRepeat: number,
          symbolMargin: 4,
          symbol: 'rect',
          symbolClip: true,
          symbolSize: [1, 5],
          symbolPosition: 'start',
          symbolOffset: [1, -1],
          // symbolBoundingData: this.total,
          data: category,
          z: 5,
          animationEasing: 'elasticOut',
        },
        {
          // 外边框
          type: 'pictorialBar',
          symbol: 'rect',

          symbolBoundingData: total,
          itemStyle: {
            normal: {
              color: 'none',
            },
          },
          data: datas,
          z: 5,
          animationEasing: 'elasticOut',
        },
        {
          name: '外框',
          type: 'bar',
          barGap: '-130%', // 设置外框粗细
          data: [total],
          barWidth: 10,
          itemStyle: {
            normal: {
              color: 'transparent', // 填充色
              barBorderColor: border, // 边框色
              barBorderWidth: 1, // 边框宽度
              barBorderRadius: 30, //圆角半径
              label: {
                // 标签显示位置
                show: false,
                position: 'top', // insideTop 或者横向的 insideLeft
              },
            },
          },
          z: 0,
        },
      ],
    }
    let category1 = [{ name: '', value: internalResistanceScore }] // 类别
    var datas: any = []
    let internalResistanceEvaluate = res.internalResistanceEvaluate
    category1.forEach((value) => {
      datas.push(value.value)
    })
    var option1 = {
      grid: {
        left: '5%',
        top: '10%', // 设置条形图的边距
        right: '5%',
        bottom: '10%',
      },
      xAxis: {
        max: total,
        show: false,
      },
      yAxis: [
        {
          type: 'category',
          inverse: false,
          data: category1,
          show: false,
        },
      ],
      series: [
        {
          // 内
          type: 'bar',
          barWidth: 6,
          legendHoverLink: false,
          silent: true,
          itemStyle: {
            color: color1,
            barBorderRadius: 10,
          },
          // label: {
          //   show: true,
          //   position: "top",
          //   color: color,
          //   formatter: function (data: any) {
          //     return data.value + `(${internalResistanceEvaluate})`;
          //   },
          // },
          data: category1,
          z: 0,
          animationEasing: 'elasticOut',
        },
        {
          // 分隔
          type: 'pictorialBar',
          itemStyle: {
            normal: {
              color: 'white',
            },
          },
          symbolRepeat: number1,
          symbolMargin: 4,
          symbol: 'rect',
          symbolClip: true,
          symbolSize: [1, 5],
          symbolPosition: 'start',
          symbolOffset: [1, -1],
          // symbolBoundingData: this.total,
          data: category1,
          z: 2,
          animationEasing: 'elasticOut',
        },
        {
          // 外边框
          type: 'pictorialBar',
          symbol: 'rect',

          symbolBoundingData: total,
          itemStyle: {
            normal: {
              color: 'none',
            },
          },
          data: datas,
          z: 0,
          animationEasing: 'elasticOut',
        },
        {
          name: '外框',
          type: 'bar',
          barGap: '-130%', // 设置外框粗细
          data: [total],
          barWidth: 10,
          itemStyle: {
            normal: {
              color: 'transparent', // 填充色
              barBorderColor: border1, // 边框色
              barBorderWidth: 1, // 边框宽度
              barBorderRadius: 30, //圆角半径
              label: {
                // 标签显示位置
                show: false,
                position: 'top', // insideTop 或者横向的 insideLeft
              },
            },
          },
          z: 5,
        },
      ],
    }
    let category2 = [{ name: '', value: voltConsistenceScore }] // 类别
    var datas: any = []
    let voltConsistenceEvaluate = res.voltConsistenceEvaluate
    category2.forEach((value) => {
      datas.push(value.value)
    })
    var option2 = {
      grid: {
        left: '5%',
        top: '10%', // 设置条形图的边距
        right: '5%',
        bottom: '10%',
      },
      xAxis: {
        max: total,
        show: false,
      },
      yAxis: [
        {
          type: 'category',
          inverse: false,
          data: category2,
          show: false,
        },
      ],
      series: [
        {
          // 内
          type: 'bar',
          barWidth: 6,
          legendHoverLink: false,
          silent: true,
          itemStyle: {
            color: color2,
            barBorderRadius: 20,
          },

          // label: {
          //   show: true,
          //   position: "top",
          //   color: color,
          //   formatter: function (data: any) {
          //     return data.value + `(${voltConsistenceEvaluate})`;
          //   },
          // },
          data: category2,
          z: 0,
          animationEasing: 'elasticOut',
        },
        {
          // 分隔
          type: 'pictorialBar',
          itemStyle: {
            normal: {
              color: 'white',
            },
          },
          symbolRepeat: number2,
          symbolMargin: 4,
          symbol: 'rect',
          symbolClip: true,
          symbolSize: [1, 5],
          symbolPosition: 'start',
          symbolOffset: [1, -1],
          // symbolBoundingData: this.total,
          data: category2,
          z: 2,
          animationEasing: 'elasticOut',
        },
        {
          // 外边框
          type: 'pictorialBar',
          symbol: 'rect',

          symbolBoundingData: total,
          itemStyle: {
            normal: {
              color: 'none',
            },
          },
          data: datas,
          z: 0,
          animationEasing: 'elasticOut',
        },
        {
          name: '外框',
          type: 'bar',
          barGap: '-130%', // 设置外框粗细
          data: [total],
          barWidth: 10,
          itemStyle: {
            normal: {
              color: 'transparent', // 填充色
              barBorderColor: border2, // 边框色
              barBorderWidth: 1, // 边框宽度
              barBorderRadius: 30, //圆角半径
              label: {
                // 标签显示位置
                show: false,
                position: 'top', // insideTop 或者横向的 insideLeft
              },
            },
          },
          z: 5,
        },
      ],
    }

    let category3 = [{ name: '', value: selfDischargeRateScore }] // 类别
    var datas: any = []
    let selfDischargeRateEvaluate = res.selfDischargeRateEvaluate
    category3.forEach((value) => {
      datas.push(value.value)
    })
    var option3 = {
      grid: {
        left: '5%',
        top: '10%', // 设置条形图的边距
        right: '5%',
        bottom: '10%',
      },
      xAxis: {
        max: total,
        show: false,
      },
      yAxis: [
        {
          type: 'category',
          inverse: false,
          data: category3,
          show: false,
        },
      ],
      series: [
        {
          // 内
          type: 'bar',
          barWidth: 6,
          legendHoverLink: false,
          silent: true,
          itemStyle: {
            color: color3,
            barBorderRadius: 20,
          },
          // label: {
          //   show: true,
          //   position: "top",
          //   color: color,
          //   formatter: function (data: any) {
          //     return data.value + `(${selfDischargeRateEvaluate})`;
          //   },
          // },
          data: category3,
          z: 0,
          animationEasing: 'elasticOut',
        },
        {
          // 分隔
          type: 'pictorialBar',
          itemStyle: {
            normal: {
              color: 'white',
            },
          },
          symbolRepeat: number3,
          symbolMargin: 4,
          symbol: 'rect',
          symbolClip: true,
          symbolSize: [1, 5],
          symbolPosition: 'start',
          symbolOffset: [1, -1],
          // symbolBoundingData: this.total,
          data: category3,
          z: 2,
          animationEasing: 'elasticOut',
        },
        {
          // 外边框
          type: 'pictorialBar',
          symbol: 'rect',
          symbolPosition: 'center',
          symbolBoundingData: total,
          itemStyle: {
            normal: {
              color: 'none',
            },
          },
          data: datas,
          z: 0,
          animationEasing: 'elasticOut',
        },
        {
          name: '外框',
          type: 'bar',
          barGap: '-130%', // 设置外框粗细
          data: [total],
          barWidth: 10,
          itemStyle: {
            normal: {
              color: 'transparent', // 填充色
              barBorderColor: border3, // 边框色
              barBorderWidth: 1, // 边框宽度
              barBorderRadius: 30, //圆角半径
              label: {
                // 标签显示位置
                show: false,
                position: 'insideTop', // insideTop 或者横向的 insideLeft
              },
            },
          },
          z: 5,
        },
      ],
    }
    let category4 = [{ name: '', value: temperatureConsistenceScore }] // 类别
    var datas: any = []
    let temperatureConsistenceEvaluate = res.temperatureConsistenceEvaluate
    category4.forEach((value) => {
      datas.push(value.value)
    })
    var option4 = {
      grid: {
        left: '5%',
        top: '10%', // 设置条形图的边距
        right: '5%',
        bottom: '10%',
      },
      xAxis: {
        max: total,
        show: false,
      },
      yAxis: [
        {
          type: 'category',
          inverse: false,
          data: category4,
          show: false,
        },
      ],
      series: [
        {
          // 内
          type: 'bar',
          barWidth: 6,

          legendHoverLink: false,
          silent: true,
          itemStyle: {
            color: color4,
            barBorderRadius: 20,
          },
          // label: {
          //   show: true,
          //   position: "top",
          //   color: color,
          //   formatter: function (data: any) {
          //     return data.value + `(${temperatureConsistenceEvaluate})`;
          //   },
          // },
          data: category4,
          z: 0,
          animationEasing: "elasticOut",
        },
        {
          // 分隔
          type: 'pictorialBar',
          itemStyle: {
            normal: {
              color: 'white',
            },
          },
          symbolRepeat: number4,
          symbolMargin: 4,
          symbol: 'rect',
          symbolClip: true,
          symbolSize: [1, 5],
          symbolPosition: 'start',
          symbolOffset: [1, -1],
          // symbolBoundingData: this.total,
          data: category4,
          z: 2,
          animationEasing: 'elasticOut',
        },
        {
          // 外边框
          type: 'pictorialBar',
          symbol: 'rect',
          symbolBoundingData: total,
          itemStyle: {
            normal: {
              color: 'none',
            },
          },
          data: datas,
          z: 0,
          animationEasing: 'elasticOut',
        },
        {
          name: '外框',
          type: 'bar',
          barGap: '-130%', // 设置外框粗细
          data: [total],
          barWidth: 10,
          itemStyle: {
            normal: {
              color: 'transparent', // 填充色
              barBorderColor: border4, // 边框色
              barBorderWidth: 1, // 边框宽度
              barBorderRadius: 30, //圆角半径
              label: {
                // 标签显示位置
                show: false,
                position: 'top', // insideTop 或者横向的 insideLeft
              },
            },
          },
          z: 5,
        },
      ],
    }
    myChart.setOption(option)
    myChart1.setOption(option1)
    myChart2.setOption(option2)
    myChart3.setOption(option3)
    myChart4.setOption(option4)
  }
  // mycharts(res: any) {
  //   var chartDom = document.getElementById("main");
  //   var myChart = (this as any).$echarts.init(chartDom);
  //   let lists = res.data.data;
  //   var option = {
  //     legend: {
  //       bottom: "5%", //图例距离整个容器底部的距离
  //       left: "center", //图例距离整个容器左边
  //       icon: "none", //设置图例图标的形状为实心圆，这个不填，默认是矩形
  //       itemHeight: 9, //图例图标的高度
  //       itemWidth: 1, //图例图标的宽度
  //       itemGap: 25, //图例图标与文字间的间距
  //       textStyle: {
  //         fontSize: 18, //图例文字字体大小
  //         color: "#333333", //图例文字颜色
  //       },
  //     },
  //     series: [
  //       {
  //         name: "一般",
  //         type: "pie",
  //         //起始刻度的角度，默认为 90 度，即圆心的正上方。0 度为圆心的正右方。
  //         startAngle: 0,
  //         hoverAnimation: false,
  //         tooltip: {},
  //         radius: ["70%", "100%"],
  //         center: ["50%", "50%"],
  //         height: "100px",
  //         labelLine: {
  //           normal: {
  //             show: false,
  //           },
  //         },
  //         data: [
  //           {
  //             value: 300,
  //             itemStyle: {
  //               normal: {
  //                 color: "rgba(80,150,224,0)",
  //               },
  //             },
  //           },
  //           {
  //             value: 250, // 渐变色部分
  //             itemStyle: {
  //               color: new (this as any).$echarts.graphic.LinearGradient(0, 0, 0, 1, [
  //                 { offset: 0, color: "#FFDE00" },
  //                 { offset: 0.5, color: "#00ECD9" },
  //                 { offset: 1, color: "#00ECD9" },
  //               ]),
  //             },
  //             name: lists.fullChargedDrivingMile + "km",
  //           },
  //           {
  //             value: 50, // 右侧部分
  //             itemStyle: {
  //               normal: {
  //                 color: "#dbe9f5",
  //               },
  //             },
  //           },
  //         ],
  //       },
  //     ],
  //   };
  //   option && myChart.setOption(option);
  // }
  getrglOnLine() {
    getrglOnLine(this.orderId).then((res) => {
      this.lists = res.data.data
      // this.mycharts(res);
      this.range(res.data.data)
      this.range2(res.data.data)
    })
  }
  mounted() {
    window.scrollTo(0, 0);
    this.getrglOnLine();
  }
  htmlToCanvas() {
    this.isDom = false
    ;(this.$refs as any).imageDom.style.paddingBottom = '30px'
    let that = this
    this.Overlay = true
    this.$dialog.confirm({
      title: '确定将报告生成图片',
      beforeClose(action, done) {
        if (action === 'confirm') {
          done()
          that.Overlay = false
          that.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner',
          })
          that.toimg()
        } else {
          done()
          that.Overlay = false
          that.isDom = true
        }
      },
    })
  }

  toimg() {
    this.$nextTick(() => {
      setTimeout(() => {
        setTimeout(() => {
          html2canvas((this.$refs as any).imageDom, { scale: 1.9 }).then(
            (canvas) => {
              let imageUrl = canvas.toDataURL('image/png') // 将canvas转成base64图片格式
              this.canvasImageUrl = imageUrl
              this.$router.push({
                path: '/webPng',
                query: { canvasImageUrl: this.canvasImageUrl },
              })
            },
          )
        }, 1000)
      }, 2000)
    })
  }

  created() {
    this.orderId = this.$route.query.orderId
  }
}
